import { copyTextToBufferWithBrowserApi } from '../../../../alan_btn/src/helpers/mini/copyTextToBuffer';
import { prepareJsonString } from './prepareJsonString';

function copyJSONToBuffer(text: string) {
    try {
        const formattedValue = JSON.stringify(JSON.parse(text), null, 4);
        copyTextToBufferWithBrowserApi(formattedValue);

    } catch (error) {

        try {
            const formattedValue = JSON.stringify(JSON.parse(prepareJsonString(text)), null, 4);
            copyTextToBufferWithBrowserApi(formattedValue);
        } catch (error) {
            copyTextToBufferWithBrowserApi(text);
        }
    }
}
export default copyJSONToBuffer;
